import React, { useMemo } from 'react'
import { ApolloProviders as SharedApolloProviders } from '@fs/zion-rootstech'
import { useFeatureFlag } from '@fs/zion-flags'
import { i18n } from '@fs/zion-locale'
import { getConfig } from '../../lib/helpers'
import { brightspotConfig, getBrightspot5ApiUri, FLAGS } from '../../config'
import { BRIGHTSPOT5_FLAG } from '../../config/feature/flags'

const ApolloProviders = ({ children }) => {
  const persistQueries = useFeatureFlag(FLAGS.PERSIST_QUERIES)
  const brightspot5 = useFeatureFlag(BRIGHTSPOT5_FLAG)

  const envConfig = useMemo(() => {
    const brightspot5Uri = brightspot5.isOn && getBrightspot5ApiUri()
    return brightspot5Uri ? { ...getConfig(), uri: brightspot5Uri } : getConfig()
  }, [brightspot5.isOn])

  return (
    <SharedApolloProviders
      persistQueries={persistQueries.isOn}
      userLocale={i18n.language}
      envConfig={envConfig}
      apiPaths={brightspotConfig.apiPaths}
    >
      {children}
    </SharedApolloProviders>
  )
}

export default ApolloProviders
